import React, { useState } from "react";
import { Images, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { renderCarousel, downloadZip } from "../../lib/lmnpCarousel";

// Bloc « Carrousel Instagram » réutilisable : aperçu des visuels + téléchargement ZIP.
export const CarouselBox = ({ slides, data, name, onMake, testid = "carousel" }) => {
  const [imgs, setImgs] = useState(null);
  const [busy, setBusy] = useState(false);
  const make = async () => {
    setBusy(true); onMake?.();
    try { setImgs(await renderCarousel(slides, data)); } catch { toast.error("Création des visuels impossible"); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-[10px] border border-brand-soft bg-white p-4" data-testid={testid}>
      <p className="font-semibold text-sm text-brand-greenDeep flex items-center gap-2"><Images className="w-4 h-4" /> Carrousel Instagram de ce résultat</p>
      <p className="text-xs text-brand-green/60 mt-1">{slides.length} visuels carrés 1080 px aux couleurs 360immoinvest, prêts à publier.</p>
      {!imgs ? (
        <button onClick={make} disabled={busy} className="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-greenDeep text-white text-sm font-semibold disabled:opacity-60" data-testid={`${testid}-make`}>{busy && <Loader2 className="w-4 h-4 animate-spin" />} Créer les visuels</button>
      ) : (
        <>
          <div className="mt-3 grid grid-cols-3 gap-2" data-testid={`${testid}-preview`}>{imgs.map((u, i) => <img key={i} src={u} alt={`Visuel ${i + 1}/${imgs.length}`} className="w-full aspect-square rounded border border-brand-soft" data-testid={`${testid}-img-${i + 1}`} />)}</div>
          <div className="mt-3 flex flex-wrap gap-2">
            <button onClick={() => downloadZip(imgs, `360immoinvest-${name}`, `carrousel-${name}.zip`)} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-lime text-brand-greenDeep text-sm font-semibold" data-testid={`${testid}-download`}><Download className="w-4 h-4" /> Télécharger les {imgs.length} images (ZIP)</button>
            <button onClick={make} className="px-4 py-2 rounded-full border border-brand-soft text-sm" data-testid={`${testid}-refresh`}>Régénérer</button>
          </div>
        </>
      )}
    </div>
  );
};
